import React, { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import Pagination from "../../Components/Pagination";
import Select from "../../Components/Select";
import { Input } from "design-react-kit";

function ListRendicontazione(props) {
  const apiToken = useContext(TokenContext);
  const [fondiList, setFondiList] = useState([]);
  const [fondiListTemp, setFondiListTemp] = useState();
  const [isOpenDel, toggleModalDel] = useState(false);
  const [isOpenTrasferisci, toggleModalTrasferisci] = useState(false);
  const [isOpenFreeze, toggleModalFreeze] = useState(false);
  const [isOpenAggiorna, toggleModalAggiorna] = useState(false);
  const [removableFondo, setRemovableFondo] = useState("");
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [fondoId, setFondoId] = useState(null);
  const [fondiSelectList, setFondiSelectList] = useState([]);

  const initialSpostaStanziato = {
    fondoDonatoreId: null,
    fondoRiceventeId: null,
    spostamento: 0,
  };

  const [spostaStanziato, setSpostaStanziato] = useState(
    initialSpostaStanziato
  );

  useEffect(() => {
    setLoading(false);
    Repo.getFondiListaOperator(apiToken, "", "")
      .then((response) => {
        setFondiListTemp(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  }, []);

  useEffect(() => {
    if (fondoId) {
      setLoading(false);
      Repo.getFondiSelectOperator(apiToken, fondoId)
        .then((response) => {
          setFondiSelectList(response.data);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    }
  }, [fondoId]); // Aggiungi fondoId come dipendenza

  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      setSpostaStanziato({
        ...spostaStanziato,
        fondoDonatoreId: selectedOption.value,
        fondoRiceventeId: fondoId,
      });
      setFondoId(selectedOption);
    }
  };

  const trasferisciStanziato = () => {
    Repo.spostaFondi(apiToken, spostaStanziato)
      .then((response) => {
        if (response.status == 200 || response.status == 204) {
          setRemovableFondo("");
          window.location.href = props.subfolder + "/rendicontazione";
        }
      })
      .catch((error) => {
        console.log(error);
        setRemovableFondo("");
        setIsAlertVisible(true);
      });
  };

  const removeRangeAPI = () => {
    Repo.deleteFondoOperator(apiToken, removableFondo)
      .then((response) => {
        if (response.status == 200 || response.status == 204) {
          setRemovableFondo("");
          window.location.href = props.subfolder + "/rendicontazione";
        }
      })
      .catch((error) => {
        console.log(error);
        setRemovableFondo("");
        setIsAlertVisible(true);
      });
  };

  const freezeAPI = () => {
    Repo.freezeFondoOperator(apiToken, "", "")
      .then((response) => {
        if (response.status == 200 || response.status == 204) {
          setRemovableFondo("");
          window.location.href = props.subfolder + "/rendicontazione";
        }
      })
      .catch((error) => {
        console.log(error);
        setRemovableFondo("");
        setIsAlertVisible(true);
      });
  };

  const aggiornaFondiAPI = () => {
    Repo.aggiornaFondoOperator(apiToken, "", "")
      .then((response) => {
        if (response.status == 200 || response.status == 204) {
          setRemovableFondo("");
          window.location.href = props.subfolder + "/rendicontazione";
        }
      })
      .catch((error) => {
        console.log(error);
        setRemovableFondo("");
        setIsAlertVisible(true);
      });
  };

  const bodyTrasferisci = () => {
    return (
      <>
        <div className="row mb-lg-3">Trasferisci Stanziato</div>

        <div className="row">
          <div className="bootstrap-select-wrapper col-md-12 text-left">
            <Select
              aria-label="Scegli una fondo donatore"
              clearText="Annulla"
              defaultMenuIsOpen={false}
              icon={false}
              name="fondoId"
              id="fondoId"
              onChange={handleSelectChange}
              options={fondiSelectList}
              value={fondoId || ""}
              isClearable
              isSearchable
              placeholder={"Scegli un fondo donatore"}
            />
          </div>

          <div className="fbootstrap-select-wrapper col-md-12 text-left">
            <label htmlFor="spostamento">Spostamento</label>
            <Input
              id="spostamento"
              type="number"
              name="spostamento"
              value={
                spostaStanziato ? spostaStanziato.spostamento.toString() : ""
              }
              onChange={(e) =>
                setSpostaStanziato({
                  ...spostaStanziato,
                  spostamento: parseFloat(e.target.value),
                })
              }
            />
          </div>
        </div>
      </>
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAlertVisible(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [isAlertVisible]);

  return (
    <>
      <div>
        <h1>Rendicontazione</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Riepilogo rendicontazione</p>
        </div>
        <div className="row mt-2 text-right">
          <div className="col-lg-12 clearfix">
            <button
              className="btn btn-outline-success p-2 ml-2"
              type="button"
              title="Aggiorna impegnato"
              onClick={() => {
                aggiornaFondiAPI();
              }}
            >
              <svg className="icon icon-success">
                <use href={`${iconSprite}#it-refresh`} />
              </svg>
              Aggiorna fondo
            </button>

            <button
              className="btn btn-outline-warning p-2 ml-2"
              type="button"
              title="Freeze"
              onClick={() => {
                toggleModalFreeze(!isOpenTrasferisci);
              }}
            >
              <svg className="icon icon-warning">
                <use href={`${iconSprite}#it-pin`} />
              </svg>
              Freeze
            </button>

            <a
              href={`${props.subfolder}/rendicontazione/nuovo_fondo`}
              className="btn btn-outline-primary  p-2 ml-2"
              title="Nuovo fondo"
            >
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-plus-circle`} />
              </svg>{" "}
              Nuovo fondo{" "}
            </a>
          </div>
        </div>
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col">Descrizione</th>
              <th scope="col">Ex Bilancio</th>
              <th scope="col">Stanziato</th>
              <th scope="col">Impegnato</th>
              <th scope="col">Disponibilità</th>
              <th scope="col">Data Freeze</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {fondiList &&
              fondiList.length > 0 &&
              fondiList.map((x, index) => (
                <React.Fragment key={index}>
                  <tr key={index}>
                    <td>{x.descrizione}</td>
                    <td>
                      Cap.{x.capitolo} Art.{x.articolo}
                    </td>
                    <td className="text-right">
                      {x.stanziato.toLocaleString("it-IT", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                    <td className="text-right">
                      {x.impegnato.toLocaleString("it-IT", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                    <td className="text-right">
                      {(x.stanziato - x.impegnato).toLocaleString("it-IT", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                    <td>{x.dataFreeze}</td>

                    <td className="text-right">
                      <button
                        className="btn btn-outline-primary p-1"
                        type="button"
                        title="Trasferisci"
                        onClick={() => {
                          setFondoId(x.id);
                          toggleModalTrasferisci(!isOpenTrasferisci);
                        }}
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-exchange-circle`} />
                        </svg>
                      </button>

                      <a
                        href={`${props.subfolder}/rendicontazione/modifica_fondo/${x.id}`}
                        className="btn btn-outline-primary p-1 ml-1"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Visualizza"
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-search`} />
                        </svg>
                      </a>
                      <button
                        className="btn btn-outline-danger p-1 ml-1"
                        type="button"
                        title="Elimina"
                        onClick={() => {
                          toggleModalDel(!isOpenDel);
                          setRemovableFondo(x.id);
                        }}
                      >
                        <svg className="icon icon-danger">
                          <use href={`${iconSprite}#it-delete`} />
                        </svg>
                      </button>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        </table>

        {fondiListTemp && (
          <Pagination
            items={fondiListTemp}
            setCurrentItems={setFondiList}
            itemsPerPage={10}
          ></Pagination>
        )}
      </div>
      <ModalComponent
        toggleModa={toggleModalDel}
        isOpen={isOpenDel}
        header={"Rimozione voce spesa"}
        body={"Confermi di voler rimuovere la voce di spesa?"}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => removeRangeAPI()}
      ></ModalComponent>

      <ModalComponent
        toggleModa={toggleModalFreeze}
        isOpen={isOpenFreeze}
        header={"Freeze fondi"}
        body={"Confermi di voler freezare in data di oggi?"}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => freezeAPI()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalTrasferisci}
        isOpen={isOpenTrasferisci}
        header={"Trasferisci"}
        body={bodyTrasferisci()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => trasferisciStanziato()}
      ></ModalComponent>

      {isAlertVisible && (
        <>
          <div
            className="alert alert-danger"
            role="alert"
            style={{
              position: "fixed",
              bottom: 0,
              right: "15px",
              backgroundColor: "#fff",
              width: "22%",
              zIndex: 10000,
            }}
          >
            <b>Non è possibile completare il trasferimento</b>
          </div>
        </>
      )}
      {!loading && <Loader></Loader>}
    </>
  );
}

export default ListRendicontazione;
